import $ from 'jquery';

$('[data-drilldown]').each((i, element) => {
    const $el = $(element);

    setTimeout(()=>{
        $el.find('li.current-menu-item > a, li.current-menu-ancestor > a').click();
    }, 0);
});


// WEBPACK FOOTER //
// ./src/layout/partials/menu-drilldown.js